import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EditServicesComponent } from '@teem/service-module/modals/edit-services/edit-services.component';
import { StoreServiceService } from '@teem/services/store-service.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { StoreService } from '@teem/models/store-service';

@Component({
  selector: 'service-grid',
  templateUrl: './service-grid.component.html',
  styleUrls: ['./service-grid.component.scss']
})
export class ServiceGridComponent implements OnInit {
  @Output() onEditService: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Input() paginator;
  @Input('myServices') myServices: StoreService[];
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  service: any = {};
  selectKey: string = 'uuid';
  basicInfo: any;
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  showMenu: boolean = false;

  constructor(
    private storeServiceService: StoreServiceService,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal
  ) { }


  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
  }

  editService(service: any) {
    this.loaderService.startLoading();
    this.storeServiceService.get(service.uuid).subscribe(service => {
      this.service = service;
      this.openEditProductModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditProductModal() {
    let modalRef = this.modalService.open(EditServicesComponent);
    modalRef.componentInstance.serviceInfo = this.service;

    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;
    // parentElement.id = "add-product-service";
    // parentElement.classList.add("new-product-service");
    parentElement.id = "add-service";
    parentElement.classList.add( "store");

    modalRef.result.then(
      onfulfilled => {
        this.onEditService.emit();
      },
      onrejected => {

      }
    );
  }

  toggleSelect(id: any, row: any) {
    let index = this.selected.indexOf(id);
    if (index == -1) {
      this.selected.push(id);
      this.selectedRows[row[this.selectKey]] = row;
      // this.onSelect.emit(Object.values(this.selectedRows))
      this.onSelect.emit(Object.values(this.selected))
    } else {
      this.selected.splice(index, 1);
      delete this.selectedRows[row[this.selectKey]];
      // this.onSelect.emit(Object.values(this.selectedRows));
      this.onSelect.emit(Object.values(this.selected));
      if (this.selected.length == 0) {
        this.showMenu = false;
      }
    }
  }

  deleteService(service) {
    this.onDelete.emit(service);
  }

  showHideService(service: any) {
    this.loaderService.startLoading();
    this.storeServiceService.action({'do': 'status-update', 'ids': [service.uuid]}).subscribe(service => {
      this.service = service;
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

}
